import factory from './icon';
import Svg from './glyphs/filter.svg';

export default factory(Svg);
